__turbopack_context__.v({
  "className": "ms_madi_453fe5d0-module__CXuyFW__className",
  "variable": "ms_madi_453fe5d0-module__CXuyFW__variable",
});
